/**
 * Menú del portal, declarativo. Cada ítem lleva el rol que necesita: la barra
 * no decide nada, solo lee esta tabla.
 *
 * `rolMinimo: null` = visible para cualquiera con sesión. El back vuelve a
 * exigir el rol en cada ruta: esto solo decide qué se dibuja.
 */

import {
  FileSpreadsheet,
  CalendarClock,
  Fingerprint,
  Settings,
  Users,
  type LucideIcon,
} from 'lucide-react';

import type { RolPortal } from './api';

export type ClaveSeccion =
  | 'novedades'
  | 'asistencia'
  | 'quilmes'
  | 'configuracion'
  | 'usuarios';

export interface Seccion {
  readonly clave: ClaveSeccion;
  readonly etiqueta: string;
  readonly icono: LucideIcon;
  readonly rolMinimo: RolPortal | null;
}

export const SECCIONES: readonly Seccion[] = [
  {
    clave: 'novedades',
    etiqueta: 'Novedades TMS → Visma',
    icono: FileSpreadsheet,
    rolMinimo: null,
  },
  {
    clave: 'asistencia',
    etiqueta: 'Asistencia al viaje',
    icono: CalendarClock,
    rolMinimo: null,
  },
  {
    /*
     * El portal es el sistema CONSUMIDOR de la integración de fichadas hacia
     * Quilmes: lee sus marcas rechazadas y avisa. No replica fichadas ni
     * decide reintentos — eso sigue siendo de ese proyecto.
     */
    clave: 'quilmes',
    etiqueta: 'Fichadas VISMA → Quilmes',
    icono: Fingerprint,
    rolMinimo: null,
  },
  {
    // El calendario de feriados lo carga quien liquida, no solo el
    // administrador: sin él, las novedades de Preventa van al concepto
    // equivocado y el período se atrasa esperando un alta (22-09-2026).
    clave: 'configuracion',
    etiqueta: 'Configuración',
    icono: Settings,
    rolMinimo: null,
  },
  {
    clave: 'usuarios',
    etiqueta: 'Usuarios',
    icono: Users,
    rolMinimo: 'admin',
  },
];

export function esClaveSeccion(valor: string): valor is ClaveSeccion {
  return SECCIONES.some((s) => s.clave === valor);
}
